module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/shop-items/shop-items.component.css
// module id = ./src/app/admin/shop-items/shop-items.component.css
// module chunks = main